// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"or_a bhs_a bhs_x","FilterForm__vgroup":"or_b bhs_rp"};